import { render, staticRenderFns } from "./orderserviceitemlist.vue?vue&type=template&id=a88bccaa&scoped=true&"
import script from "./orderserviceitemlist.vue?vue&type=script&lang=js&"
export * from "./orderserviceitemlist.vue?vue&type=script&lang=js&"
import style0 from "./orderserviceitemlist.vue?vue&type=style&index=0&id=a88bccaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88bccaa",
  null
  
)

export default component.exports